export const FinancialAccountCypressAttribute = {
  buttons: {
    ADD_CONNECTION: 'FinancialAccountCypressAttribute:buttons:ADD_CONNECTION',
    ADD_MORE_CONNECTIONS: 'FinancialAccountCypressAttribute:buttons:ADD_MORE_CONNECTIONS',
    ADD_BANKING: 'FinancialAccountCypressAttribute:buttons:ADD_BANKING',
    ADD_FINANCIAL_ACCOUNT: 'FinancialAccountCypressAttribute:buttons:ADD_FINANCIAL_ACCOUNT',
    ADD_INVESTMENT: 'FinancialAccountCypressAttribute:buttons:ADD_INVESTMENT',
    ADD_NOTE: 'FinancialAccountCypressAttribute:buttons:ADD_NOTE',
    ADD_TRANSACTION: 'FinancialAccountCypressAttribute:buttons:ADD_TRANSACTION',
    ADD_TRANSACTION_DROPDOWN: 'FinancialAccountCypressAttribute:buttons:ADD_TRANSACTION_DROPDOWN',
    RELOAD_BALANCES: 'FinancialAccountCypressAttribute:buttons:RELOAD_BALANCES',
    RELOAD_BALANCES_ON_RETRY_LATER:
      'FinancialAccountCypressAttribute:buttons:RELOAD_BALANCES_ON_RETRY_LATER',
    RELOAD_BALANCE: 'FinancialAccountCypressAttribute:buttons:RELOAD_BALANCE',
    UNLINK: 'FinancialAccountCypressAttribute:buttons:UNLINK',
    RECONNECT: 'FinancialAccountCypressAttribute:buttons:RECONNECT',
    UNLINK_ALL: 'FinancialAccountCypressAttribute:buttons:UNLINK_ALL',
    ACCOUNT_ACTIONS: 'FinancialAccountCypressAttribute:buttons:ACCOUNT_ACTIONS',
    DISCARD_ALL: 'FinancialAccountCypressAttribute:buttons:DISCARD_ALL',
    SAVE_ALL: 'FinancialAccountCypressAttribute:buttons:SAVE_ALL',
    DISCARD: 'FinancialAccountCypressAttribute:buttons:DISCARD',
    SAVE: 'FinancialAccountCypressAttribute:buttons:SAVE',
    DELETE_TRANSACTION: 'FinancialAccountCypressAttribute:buttons:DELETE_TRANSACTION',
    IMPORT_BANK_STATEMENT: 'FinancialAccountCypressAttribute:buttons:IMPORT_BANK_STATEMENT',
    CHANGE_CATEGORY: 'FinancialAccountCypressAttribute:buttons:CHANGE_CATEGORY',
    BACK_TO_DETAIL: 'FinancialAccountCypressAttribute:buttons:BACK_TO_DETAIL',
    CANCEL_LINK_ENTITIES: 'FinancialAccountCypressAttribute:buttons:CANCEL_LINK_ENTITIES',
    SAVE_LINK_ENTITIES: 'FinancialAccountCypressAttribute:buttons:SAVE_LINK_ENTITIES'
  },
  inputs: {
    FLINKS_TYPE_RADIO_BOX: 'FinancialAccountCypressAttribute:inputs:FLINKS_TYPE_RADIO_BOX',
    CATEGORY_SELECT: 'FinancialAccountCypressAttribute:inputs:CATEGORY_SELECT',
    RELATIONSHIP_SELECT: 'FinancialAccountCypressAttribute:inputs:RELATIONSHIP_SELECT'
  },
  views: {
    BALANCES_PROGRESS_BANNER: 'FinancialAccountCypressAttribute:BALANCES_PROGRESS_BANNER',
    BALANCES_BANNER: 'FinancialAccountCypressAttribute:BALANCES_BANNER',
    CONNECTIONS_LIST: 'FinancialAccountCypressAttribute:CONNECTIONS_LIST',
    EMPTY_STATE: 'FinancialAccountCypressAttribute:EMPTY_STATE',
    FLINKS_FR_EMPTY_STATE: 'FinancialAccountCypressAttribute:views:FLINKS_FR_EMPTY_STATE',
    FLINKS_ENG_EMPTY_STATE: 'FinancialAccountCypressAttribute:views:FLINKS_ENG_EMPTY_STATE',
    SECURITY_COMPLIANCE: 'FinancialAccountCypressAttribute:views:SECURITY_COMPLIANCE',
    DATA_PROGRESS_BAR: 'FinancialAccountCypressAttribute:views:DATA_PROGRESS_BAR',
    INSTITUTION_SUBTITLE: 'FinancialAccountCypressAttribute:views:INSTITUTION_SUBTITLE',
    BALANCE: 'FinancialAccountCypressAttribute:views:BALANCE',
    BANK_STATEMENTS: 'FinancialAccountCypressAttribute:views:BANK_STATEMENTS',
    LAST_SYNC: 'FinancialAccountCypressAttribute:views:LAST_SYNC'
  },
  cashflow: {
    buttons: {
      ADD_NATIONAL_BANK_CONNECTION:
        'FinancialAccountCypressAttribute:cashflow:ADD_NATIONAL_BANK_CONNECTION',
      ADD_CONNECTION: 'FinancialAccountCypressAttribute:cashflow:ADD_CONNECTION',
      EDIT_FINANCIAL_INSTITUTION:
        'FinancialAccountCypressAttribute:cashflow:EDIT_FINANCIAL_INSTITUTION',
      ADD_MANUAL_CONNECTION: 'FinancialAccountCypressAttribute:cashflow:ADD_MANUAL_CONNECTION',
      UNLINK: 'FinancialAccountCypressAttribute:cashflow:buttons:UNLINK',
      EXPORT_TRANSACTIONS: 'FinancialAccountCypressAttribute:cashflow:EXPORT_TRANSACTIONS',
      CONNECT_BANK_ACCOUNT_TO_PLAID:
        'FinancialAccountCypressAttribute:cashflow:CONNECT_BANK_ACCOUNT_TO_PLAID',
      RECOMMENDED: 'FinancialAccountCypressAttribute:cashflow:buttons:RECOMMENDED',
      MANAGE_BANK_STATEMENTS: 'FinancialAccountCypressAttribute:cashflow:MANAGE_BANK_STATEMENTS',
      EDIT_TOGGLE: 'FinancialAccountCypressAttribute:cashflow:EDIT_TOGGLE'
    },
    inputs: {
      TRANSACTION_SEARCH: 'FinancialAccountCypressAttribute:cashflow:inputs:TRANSACTION_SEARCH',
      TRANSACTION_DATE: 'FinancialAccountCypressAttribute:cashflow:inputs:TRANSACTION_DATE',
      TRANSACTION_DESCRIPTION:
        'FinancialAccountCypressAttribute:cashflow:inputs:TRANSACTION_DESCRIPTION',
      TRANSACTION_AMOUNT: 'FinancialAccountCypressAttribute:cashflow:inputs:TRANSACTION_AMOUNT'
    },
    views: {
      CONNECTIONS_LIST: 'FinancialAccountCypressAttribute:cashflow:CONNECTIONS_LIST',
      EMPTY_STATE: 'FinancialAccountCypressAttribute:cashflow:EMPTY_STATE',
      PLAID_CONNECT_CONTAINER: 'FinancialAccountCypressAttribute:cashflow:PLAID_CONNECT_CONTAINER',
      TRANSACTION_TABLE: 'FinancialAccountCypressAttribute:cashflow:TRANSACTION_TABLE',
      PENDING_NBC_STATE_BANNER:
        'FinancialAccountCypressAttribute:cashflow:PENDING_NBC_STATE_BANNER',
      LEARN_MORE_LINK: 'FinancialAccountCypressAttribute:cashflow:views:LEARN_MORE_LINK',
      INSTRUCTIONS_TEXT: 'FinancialAccountCypressAttribute:cashflow:views:INSTRUCTIONS_TEXT',
      RELATIONSHIP_LABEL: 'FinancialAccountCypressAttribute:cashflow:RELATIONSHIP_LABEL',
      RELATIONSHIP_TOOLTIP: 'FinancialAccountCypressAttribute:cashflow:RELATIONSHIP_TOOLTIP',
      CATEGORY_LABEL: 'FinancialAccountCypressAttribute:cashflow:CATEGORY_LABEL',
      CATEGORY_TOOLTIP: 'FinancialAccountCypressAttribute:cashflow:CATEGORY_TOOLTIP',
      CATEGORY_COLLAPSE: 'FinancialAccountCypressAttribute:cashflow:CATEGORY_COLLAPSE_',
      TRANSACTION_ACTIONS: 'FinancialAccountCypressAttribute:cashflow:TRANSACTION_ACTIONS'
    }
  },
  infoCollapse: {
    views: {
      FINANCIAL_ACCOUNT: 'FinancialAccountCypressAttribute:infoCollapse:FINANCIAL_ACCOUNT',
      IS_WARD_FINANCIAL_ACCOUNT:
        'FinancialAccountCypressAttribute:infoCollapse:IS_WARD_FINANCIAL_ACCOUNT',
      FINANCIAL_ACCOUNT_STATUS:
        'FinancialAccountCypressAttribute:infoCollapse:FINANCIAL_ACCOUNT_STATUS',
      FINANCIAL_ACCOUNT_COMPLETE_TRANSFER_STATUS:
        'FinancialAccountCypressAttribute:infoCollapse:FINANCIAL_ACCOUNT_COMPLETE_TRANSFER_STATUS',
      FINANCIAL_ACCOUNT_WAITING_ON_TRANSFER_STATUS:
        'FinancialAccountCypressAttribute:infoCollapse:FINANCIAL_ACCOUNT_WAITING_ON_TRANSFER_STATUS',
      SEND_REMINDER: 'FinancialAccountCypressAttribute:infoCollapse:SEND_REMINDER'
    },
    inputs: {
      SELECT_FINANCIAL_BANK: 'FinancialAccountCypressAttribute:infoCollapse:SELECT_FINANCIAL_BANK',
      INSTITUTION_INPUT: 'FinancialAccountCypressAttribute:infoCollapse:inputs:INSTITUTION_INPUT',
      TRANSIT_INPUT: 'FinancialAccountCypressAttribute:infoCollapse:TRANSIT_INPUT',
      ACCOUNT_NUMBER_INPUT: 'FinancialAccountCypressAttribute:infoCollapse:ACCOUNT_NUMBER_INPUT',
      UPLOAD_CHEQUE: 'FinancialAccountCypressAttribute:infoCollapse:UPLOAD_CHEQUE'
    },
    buttons: {
      LOG_TRANSFER_BUTTON: 'FinancialAccountCypressAttribute:infoCollapse:LOG_TRANSFER_BUTTON'
    }
  },
  editTransactionModal: {
    ENTITY_NAME: 'FinancialAccountCypressAttribute:infoCollapse:ENTITY_NAME',
    ENTITY_AMOUNT: 'FinancialAccountCypressAttribute:infoCollapse:ENTITY_AMOUNT',
    ENTITY_DATE: 'FinancialAccountCypressAttribute:infoCollapse:ENTITY_DATE',
    ASSET_SELECT: 'FinancialAccountCypressAttribute:infoCollapse:ASSET_SELECT',
    LIABILITY_SELECT: 'FinancialAccountCypressAttribute:infoCollapse:LIABILITY_SELECT',
    ENTITY_NOTE: 'FinancialAccountCypressAttribute:infoCollapse:ENTITY_NOTE',
    CONNECT_ACCOUNT: 'FinancialAccountCypressAttribute:infoCollapse:CONNECT_ACCOUNT',
    IGNORE_MISSING: 'FinancialAccountCypressAttribute:infoCollapse:IGNORE_MISSING'
  }
};
